/** CaitlynPainter — 2D rifle silhouette. */
export const CaitlynPainter = {
  paint(ctx, _pos, radius, _entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.82, 0, Math.PI * 2);
    ctx.fillStyle = '#1e3a5f';
    ctx.fill();
    ctx.beginPath();
    ctx.arc(0, -radius * 0.55, radius * 0.34, 0, Math.PI * 2);
    ctx.fillStyle = '#93c5fd';
    ctx.fill();
    ctx.fillStyle = '#cbd5e1';
    ctx.fillRect(radius * 0.2, -radius * 0.12, radius * 0.95, radius * 0.16);
  }
};
